import AbstractConfig from "../../../core/config/AbstractConfig";

export default class ScoreConfig extends AbstractConfig {
    constructor() {
        super();
    }

    getScore(playerAnswerId) {
        const scores = this.getValue('scores');
        return scores.find(score => score.playerAnswerId == playerAnswerId);
    }

    getUnlockedPath(chapter, week, score) {
        const paths = this.getValue('paths');

        // get nodes from week and chapter
        const filteredNodes = paths.filter(path => path.chapter === chapter && path.week === week);
        // sort nodes threshold
        const sortedNodes = filteredNodes.sort((a, b) => b.threshold - a.threshold);
        const firstNodeWithThreshold = sortedNodes.find(node => score >= node.threshold);

        if (firstNodeWithThreshold) {
            return firstNodeWithThreshold.path;
        }
        return null;
    }
}
